import common from "./common.json";
import transactions from "./transactions.json";
import transaction from "./transaction.json";
import taxes from "./taxes.json";
import discount from "./discount.json";
import titles from "./titles.json";
import app_update from "./app-update.json";
import dialog_questions from "./dialog-questions.json";

export default {
  common,
  transactions,
  transaction,
  taxes,
  discount,
  titles,
  app_update,
  questions: dialog_questions,
};
